/** The five "inner weather" states shared by the home check-in, the post-mission
 *  reflection and the therapist timeline. Scores line up with mood_logs.mood_score. */
export const FEELINGS = [
  { id: 'stormy', glyph: 'storm', label: 'סוער', score: 1 },
  { id: 'rainy',  glyph: 'rain',  label: 'גשום', score: 2 },
  { id: 'cloudy', glyph: 'cloud', label: 'מעונן', score: 3 },
  { id: 'breezy', glyph: 'breeze', label: 'נעים', score: 4 },
  { id: 'sunny',  glyph: 'sun',   label: 'שמשי', score: 5 },
] as const;

export type FeelingId = (typeof FEELINGS)[number]['id'];

export const feelingById = (id?: string | null) => FEELINGS.find((f) => f.id === id);
export const feelingByScore = (score?: number | null) => FEELINGS.find((f) => f.score === score);

/** A row of public.mission_reflections (see supabase/migrations/20261006_bridge_reflections.sql). */
export interface MissionReflection {
  id: number;
  user_id: string;
  mission_id: string | null;
  mission_title: string;
  feeling: FeelingId;
  created_at: string;
  therapist_heart_at: string | null;
  /** Set when the therapist opened what came back (after migration 20261007). */
  therapist_seen_at?: string | null;
}

/** First name for use inside a sentence ("פתק מדנה"). */
const TITLES = /^(ד"ר|ד״ר|דר'|דר|פרופ'|פרופ׳|פרופ|dr\.?|prof\.?)$/i;
export const firstName = (full?: string | null) =>
  (full ?? '').trim().split(/\s+/).filter((w) => !TITLES.test(w))[0] || '';

export const MISSION_TYPE: Record<string, { glyph: string; label: string }> = {
  active:   { glyph: 'steps',  label: 'תנועה' },
  mindful:  { glyph: 'lotus',  label: 'קשב' },
  creative: { glyph: 'pencil', label: 'יצירה' },
};
